import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { Avatar } from "@mui/material";
import cx from "classnames";
import type { UserPublic } from "src/queries/users/users.types";

interface UserAvatarProps {
  user?: Partial<UserPublic>;
  className?: string;
}

const UserAvatar = ({ user, className }: UserAvatarProps) => {
  const userInitials =
    `${user?.first_name?.[0] ?? ""}${user?.last_name?.[0] ?? ""}` ||
    user?.email?.[0];

  if (user?.picture) {
    return (
      <Avatar
        src={user.picture}
        alt="user avatar"
        className={cx("w-8 h-8 rounded-full", className)}
      />
    );
  }

  if (userInitials) {
    return (
      <Avatar className={cx("w-8 h-8 rounded-full", className)}>
        {userInitials}
      </Avatar>
    );
  }

  return <PersonOutlinedIcon className={cx("m-auto rounded-full", className)} />;
};

export default UserAvatar;
